import PayloadInsertCandidate from './entities/payloadInsertCandidate';
import ResponseCandidate from './entities/responseCandidate';
import CandidateRepository from './repository/CandidateRepository';
import ResponseCandidateFull from '@/modules/candidate/entities/responseCandidateFull';

class ServiceCandidate {
  constructor(readonly candidateRepository: CandidateRepository) {}

  async findByCpfDataNascimento(cpf: string, dataNascimento: string): Promise<ResponseCandidate> {
    return await this.candidateRepository.findByCpfDataNascimento(cpf, dataNascimento);
  }

  async findByCpf(): Promise<ResponseCandidateFull> {
    return await this.candidateRepository.findByCpf();
  }

  async InsertCandidate(candidate: PayloadInsertCandidate): Promise<ResponseCandidate> {
    return await this.candidateRepository.insertCandidate(candidate);
  }
}

export default ServiceCandidate;
